import { hasPermission, isOnPath } from "./apiWrapper";

const LOCATION_CHANGE = "@@router/LOCATION_CHANGE"; // hardcoded to save 9KB lib link just to get one value
const TOGGLE_RIGHT_PANEL = "TOGGLE_RIGHT_PANEL";

export const rightPanelStoreActions = {
  toggleRightPanel: (open, id) => (dispatch) =>
    dispatch({ type: TOGGLE_RIGHT_PANEL, open, id }),
};

export const rightPanelItems = [
  {
    visible: () =>
      isOnPath({ regex: /^(|\/)search($|\/$)/i }) &&
      hasPermission(null, "PanelHistory"),
    hasIconMode: false,
    onlyIconMode: false,
    order: 2,
    id: "last-searched",
    open: "openLastSearched",
  },
  {
    visible: () => isOnPath({ regex: /relation-chart\//i }),
    alwaysOpen: false,
    hasIconMode: false,
    onlyIconMode: false,
    order: 20,
    id: "chart-settings",
  },
  {
    visible: () =>
      isOnPath({
        regex: /(^(|\/)search($|\/$)|(^(|\/)report\/)|(^(|\/)search\/results))|(relation-chart\/)/i,
      }),
    hasIconMode: false,
    onlyIconMode: false,
    order: 90,
    id: "subject-clipboard",
  },
  {
    visible: () => isOnPath({ regex: /relation-chart\//i }),
    alwaysOpen: false,
    hasIconMode: false,
    onlyIconMode: false,
    order: 91,
    id: "report-legend",
  },
  {
    visible: () => isOnPath({ regex: /^(|\/)report\/(economic-group)/i }),
    hasIconMode: false,
    onlyIconMode: false,
    order: 5,
    id: "report-settings",
  },
  {
    visible: () => isOnPath({ regex: /^(|\/)report\/(monitora)/i }),
    hasIconMode: false,
    onlyIconMode: false,
    order: 6,
    id: "report-filters",
  },
  {
    visible: () => isOnPath({ regex: /(^(|\/)report\/)/i }),
    hasIconMode: true,
    onlyIconMode: true,
    order: 0,
    id: "sections-config",
    open: "openSectionsConfig",
  },
  {
    visible: () => isOnPath({ regex: /(^(|\/)report\/(?!quick))/i }),
    hasIconMode: false,
    onlyIconMode: false,
    order: 120,
    id: "sections-pdf-export",
    open: "openSectionsPdfExport",
  },
  {
    visible: () => isOnPath({ regex: /(^(|\/)search\/results)/i }),
    hasIconMode: false,
    onlyIconMode: false,
    order: 20,
    id: "search-filter",
    open: "openSearchFilter",
  },
  {
    visible: () => isOnPath({ regex: /(^(|\/)monitoring\/alerts)/i }),
    hasIconMode: false,
    onlyIconMode: false,
    order: 20,
    id: "alerts-filter",
    open: "openAlertsFilter",
  },
  {
    visible: () => isOnPath({ regex: /^(|\/)unicorn\/\w+\/parameters/ }),
    alwaysOpen: false,
    hasIconMode: false,
    onlyIconMode: false,
    order: 20,
    id: "unicorn-sections",
    open: "openUnicornSections",
  },
  {
    visible: () => isOnPath({ regex: /^(|\/)unicorn\/\w+\/configuration/ }),
    alwaysOpen: false,
    hasIconMode: false,
    onlyIconMode: false,
    order: 20,
    id: "unicorn-export-sections",
    open: "oneUnicornExportSections",
  },
  {
    visible: () => isOnPath({ regex: /^(|\/)unicorn\/\w+\/results/ }),
    hasIconMode: false,
    onlyIconMode: false,
    order: 20,
    id: "unicorn-overview",
  },
  {
    visible: (_this) =>
      ((_this.props.layout || {}).helpMap || []).filter(
        (x) =>
          x.regex !== null &&
          x.regex !== undefined &&
          new RegExp(x.regex).test(window.location.pathname)
      ).length !== 0 && hasPermission(null, "MainHelp"),
    customHandler: true,
    order: 150,
    id: "help-redirect",
  },
];

const initialState = {
  expanded: false,
  selectedId: "",
};

// store reducer
export const reducer = (state, action) => {
  state = state || initialState;
  switch (action.type) {
    case TOGGLE_RIGHT_PANEL:
      return {
        ...state,
        expanded: action.open || !state.expanded,
        selectedId: action.id,
      };
    default:
      return state;
  }
};
